import React from 'react';
import { Tag } from '@bedrock/components';

/**
 * 「是否超充 / 是否提前充值」布尔值 Tag。
 * 对齐设计稿 Figma：是=浅红（light-red）、否=浅蓝（light-blue）。
 * undefined/null 显示 --（字段未回填或隐藏时的占位，与 readOnlyText 一致）。
 */
export const RechargeBooleanTag: React.FC<{ value?: boolean | null }> = ({
  value,
}) => {
  if (value === undefined || value === null) {
    return <span className="text-color-3">--</span>;
  }
  return (
    <Tag
      text={value ? '是' : '否'}
      size="small"
      color={value ? 'light-red' : 'light-blue'}
    />
  );
};

export default RechargeBooleanTag;
